import ENDPOINT from 'constants/endPoint';
import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

export default {
  async getLocationList(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.MY_PLACE}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getIntranetLocationList(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.INTRANET_PLACES}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async exportLocationList(payload) {
    const params = getParamsFormObject(payload);
    const path = `/places/me/export${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async deleteLocation(payload) {
    const { locationId } = payload;
    const path = ENDPOINT.PLACE_DETAIL(locationId);

    const response = await axiosClient.delete(path);

    return response.data;
  },

  async getRoomStatusList(payload) {
    const params = getParamsFormObject(payload);
    const path = `/room-status${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async updateRoomStatus(payload) {
    const { roomInfo, newRoomStatus } = payload;
    const path = `/places/${roomInfo.id}/room/${roomInfo.roomId}/room-status/${roomInfo.roomStatusId}`;

    const response = await axiosClient.put(path, newRoomStatus);

    return response.data;
  },

  async quickpUdateRoomStatus(payload) {
    const { roomInfo } = payload;
    const path = `/places/${roomInfo.id}/room/${roomInfo.roomId}/room-status/${roomInfo.roomStatusId}/quick-update-status `;

    const response = await axiosClient.put(path);

    return response.data;
  },

  async getAdvanceBookingCharts(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.ANALYTICS_ADVANCE_BOOKING_CHARTS}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getStayNightsCharts(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.ANALYTICS_STAY_NIGHTS_CHARTS}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getMarketDemandCharts(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.ANALYTICS_MARKET_DEMAND_CHARTS}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getBookingStatusRatio(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.ANALYTICS_BOOKING_STATUS_RATIO}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getRevenueDistributionAccountLevels(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.ANALYTICS_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },
};
